<capra-toast class="failed-toast" type="error">
  <h4 class="toast-header">Sync failed.</h4>
  <p class="toast-text">
    This can happen when the data is incompatible, or the Dataset creator disconnects their Google Account or loses
    access to the underlying Sheet.
  </p>
</capra-toast>
